import * as React from 'react'
import { Column } from '../types'
import ColumnHiddenInputs from './column_hidden_inputs'

interface HiddenInputsProps {
  columns: Column[]
}

export default function HiddenInputs({ columns }: HiddenInputsProps) {
  return (
    <div style={{ display: 'none' }}>
      {columns.map((column, colIndex) => (
        <ColumnHiddenInputs key={column.id} column={column} index={colIndex} />
      ))}
    </div>
  )
}
